import { Navigate } from "react-router-dom";
import type { PropsWithChildren } from "react";
import { useAuth } from "./AuthContext";
import type { RoleUtilisateur } from "@sfs/contracts";

export function RouteProtegee({ children, role }: PropsWithChildren<{ role?: RoleUtilisateur }>) {
  const { utilisateur } = useAuth();
  if (!utilisateur) return <Navigate to="/connexion" replace />;
  if (role && utilisateur.role !== role) {
    return <p className="etat erreur">Cette section est réservée aux administrateurs.</p>;
  }
  return <>{children}</>;
}
